import { Icon } from '@chakra-ui/react';

export const DownloadIcon = (props) => (
  <Icon viewBox="0 0 16 16" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M8.01467 13.0001C7.69646 13.0001 7.39132 12.8766 7.16632 12.6569L2.36647 7.97116C2.13484 7.75288 2.00286 7.45284 2.00005 7.13866C1.99723 6.82447 2.124 6.52229 2.3514 6.30008C2.57901 6.07788 2.88856 5.95433 3.2104 5.95708C3.53222 5.95982 3.83956 6.08867 4.06317 6.31459L8.86302 11.0003C9.08802 11.22 9.21438 11.5181 9.21438 11.8287C9.21438 12.1393 9.08802 12.4373 8.86302 12.6569C8.63803 12.8766 8.33286 13.0001 8.01467 13.0001Z"
      fill="#1565BC"
    />
    <path
      d="M8.01489 12.9987C7.69668 12.9987 7.39154 12.8752 7.16654 12.6555C6.94154 12.4359 6.81519 12.138 6.81519 11.8274C6.81519 11.5167 6.94154 11.2188 7.16654 10.9992L11.9664 6.31342C12.2711 6.02611 12.7087 5.91668 13.1173 6.02611C13.5261 6.13554 13.8453 6.44716 13.9574 6.84606C14.0693 7.24515 13.9576 7.67208 13.6631 7.9696L8.86326 12.6554C8.63826 12.875 8.33308 12.9987 8.01489 12.9987Z"
      fill="#1565BC"
    />
    <rect x="16" y="14" width="2" height="16" rx="1" transform="rotate(90 16 14)" fill="#1565BC" />
    <path
      d="M7 1C7 0.447715 7.44772 0 8 0C8.55228 0 9 0.447715 9 1V11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11V1Z"
      fill="#1565BC"
    />
  </Icon>
);
